if (!customElements.get('promo-popup')) {
  customElements.define(
    'promo-popup',
    class PromoPopup extends HTMLElement {
      constructor() {
        super();
        this._onKeyup = this._onKeyup.bind(this);
        this._onOverlayClick = this._onOverlayClick.bind(this);
      }

      connectedCallback() {
        this.overlay = this.querySelector('.promo-popup__overlay');
        this.dialog = this.querySelector('[role="dialog"]');
        this.closeBtn = this.querySelector('.promo-popup__close');
        this.cta = this.querySelector('.promo-popup__cta');

        const delayMs = this._parseIntData('delayMs', 5000);
        const designDelayMs = this._parseIntData('designModeDelayMs', 400);
        const cookieDays = this._parseIntData('cookieDays', 7);
        const cookieName = this.dataset.cookieName;
        const closeOnBackdrop = this.dataset.closeOnBackdrop !== 'false';
        const isDesignMode = window.Shopify && window.Shopify.designMode;

        if (!cookieName || !this.dialog) return;

        if (!isDesignMode && this._getCookie(cookieName)) return;

        const wait = isDesignMode ? designDelayMs : delayMs;
        this._timer = window.setTimeout(() => this.open(), wait);

        if (this.closeBtn) {
          this.closeBtn.addEventListener('click', () => this.close());
        }
        if (this.overlay && closeOnBackdrop) {
          this.overlay.addEventListener('click', this._onOverlayClick);
        }
        if (this.cta) {
          this.cta.addEventListener('click', () => this._persistDismiss());
        }
      }

      disconnectedCallback() {
        window.clearTimeout(this._timer);
        this.overlay?.removeEventListener('click', this._onOverlayClick);
        document.removeEventListener('keyup', this._onKeyup);
        document.body.classList.remove('overflow-hidden');
        if (typeof removeTrapFocus === 'function') {
          removeTrapFocus();
        }
      }

      _parseIntData(attr, fallback) {
        const v = parseInt(this.dataset[attr], 10);
        return Number.isFinite(v) && v >= 0 ? v : fallback;
      }

      _getCookie(name) {
        const match = document.cookie.match(new RegExp('(?:^|; )' + name.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + '=([^;]*)'));
        return match ? decodeURIComponent(match[1]) : null;
      }

      _setCookie(name, days) {
        const d = new Date();
        d.setTime(d.getTime() + days * 24 * 60 * 60 * 1000);
        document.cookie = `${name}=1;expires=${d.toUTCString()};path=/;SameSite=Lax`;
      }

      _persistDismiss() {
        const cookieName = this.dataset.cookieName;
        const cookieDays = this._parseIntData('cookieDays', 7);
        if (!cookieName || (window.Shopify && window.Shopify.designMode)) return;
        this._setCookie(cookieName, cookieDays);
      }

      _onOverlayClick(event) {
        if (event.target === this.overlay) this.close();
      }

      _onKeyup(event) {
        if (event.code.toUpperCase() === 'ESCAPE') this.close();
      }

      open() {
        if (!this.dialog) return;
        this.classList.add('is-open');
        this.setAttribute('aria-hidden', 'false');
        document.body.classList.add('overflow-hidden');
        document.addEventListener('keyup', this._onKeyup);
        if (typeof trapFocus === 'function') {
          trapFocus(this.dialog, this.closeBtn || this.dialog);
        } else {
          (this.closeBtn || this.dialog).focus();
        }
      }

      close() {
        this._persistDismiss();
        this.classList.remove('is-open');
        this.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('overflow-hidden');
        document.removeEventListener('keyup', this._onKeyup);
        if (typeof removeTrapFocus === 'function') {
          removeTrapFocus(null);
        }
      }
    }
  );
}
